import { Button, SxProps, Theme, Typography } from '@mui/material';
import { baseColors } from 'utils/constants';
import { ArrowRIcon } from 'components';

type Props = {
  id?: string;
  sx?: SxProps<Theme> | undefined;
  children?: React.ReactNode;
  onClick?: () => void;
};

const TopNextButton = (props: Props) => {
  const { sx, children, onClick } = props;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    onClick && onClick();
  };

  return (
    <Button
      sx={{
        width: '200px',
        height: '40px',
        mx: 'auto',
        my: 0,
        p: 1,
        textAlign: 'center',
        bgcolor: baseColors.orange,
        borderRadius: '25px',
        boxShadow: 2,
        position: 'relative',
        ...sx
      }}
      onClick={handleClick}
    >
      <Typography
        variant="subtitle1"
        sx={{
          color: baseColors.white
        }}
      >
        {children ? children : 'プラン選択'}
      </Typography>
      <ArrowRIcon style={{ position: 'absolute', right: 20 }} />
    </Button>
  );
};

export default TopNextButton;
